import { render, staticRenderFns } from "./RemnantPastApply.vue?vue&type=template&id=729fbac3"
import script from "./RemnantPastApply.vue?vue&type=script&lang=js"
export * from "./RemnantPastApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports